import Immutable, { Record } from 'immutable';

const OverallDevelopmentItemRecord = Record({
  id: undefined,
  name: undefined,
  unitId: undefined,
  abilityId: undefined,
});

class OverallDevelopmentItem extends OverallDevelopmentItemRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
      return [key, `${val}`];
    case 'unitId':
      return [key, `${val}`];
    case 'abilityId':
      return [key, `${val}`];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

OverallDevelopmentItem.create = (data) =>
  new OverallDevelopmentItem(data).mapEntries(reviver);

export default OverallDevelopmentItem;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/OverallDevelopment/template/skills/items/model.js